import { Injectable } from '@angular/core';
import { ValidatorService } from 'src/app/core/validator/validator.service';
import { WarehouseLocation } from '../models/warehouse-location.model';

@Injectable({
  providedIn: 'root'
})
export class WarehouseLocationValidatorService extends ValidatorService {
  isValid(data: WarehouseLocation) {
    this.errors = [];

    if (!this.isDropdownSupplied(data.warehouseId)) {
      this.errors.push('warehouseId');
    }

    if (!this.isSupplied(data.aisle)) {
      this.errors.push('aisle');
    }

    if (!this.isSupplied(data.shelf)) {
      this.errors.push('shelf');
    }

    return this.errors.length === 0;
  }
}
